// One entry per ReviewSource enum value (GHL-Prime-Backend/prisma/schema.prisma).
// `url` is the real public profile to link out to; left null for OTHER since
// there's no single canonical page for it.
export const SOURCE_META = {
  GOOGLE: {
    label: 'Google',
    longLabel: 'Google Business',
    url: 'https://www.google.com/maps/place/GHL+Prime',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A10.96 10.96 0 001 12c0 1.77.42 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
      </svg>
    ),
  },
  UPWORK: {
    label: 'Upwork',
    longLabel: 'Upwork',
    url: 'https://www.upwork.com/agencies/ghlprime',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M18.561 13.158c-1.102 0-2.135-.467-3.074-1.227l.228-1.076.008-.042c.207-1.143.849-3.066 2.839-3.066 1.492 0 2.703 1.212 2.703 2.703s-1.212 2.708-2.703 2.708zm0-7.953c-2.757 0-4.876 1.753-5.744 4.603a15.898 15.898 0 01-2.032-3.308H7.591v5.337c0 1.31-1.067 2.377-2.377 2.377S2.837 13.147 2.837 11.837V6.5H.275v5.337c0 2.724 2.215 4.939 4.939 4.939s4.939-2.215 4.939-4.939V10.4a15.46 15.46 0 001.2 2.045l-1.545 7.245h2.626l1.122-5.274a8.32 8.32 0 005.005 1.655c2.906 0 5.246-2.375 5.246-5.269s-2.341-5.397-5.246-5.397z" fill="#14A800"/>
      </svg>
    ),
  },
  LINKEDIN: {
    label: 'LinkedIn',
    longLabel: 'LinkedIn',
    // Company page from lib/facts.ts `sameAs`.
    url: 'https://www.linkedin.com/company/ghl-prime-llc',
    // The square "in" mark is recognisable on its own, so no word beside it.
    iconOnly: true,
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
        <rect width="24" height="24" rx="4" fill="#0A66C2" />
        <circle cx="7.2" cy="6.9" r="1.75" fill="#fff" />
        <rect x="5.65" y="9.5" width="3.1" height="9.3" fill="#fff" />
        <path d="M10.6 9.5h2.9v1.3c.55-.95 1.65-1.55 3-1.55 2.45 0 3.4 1.6 3.4 4.15v5.4h-3.05v-4.9c0-1.25-.45-2.05-1.55-2.05-1.15 0-1.75.8-1.75 2.05v4.9H10.6z" fill="#fff" />
      </svg>
    ),
  },
  FIVERR: {
    label: 'Fiverr',
    longLabel: 'Fiverr',
    // No public GHL Prime Fiverr profile on file yet, so the mark isn't a link.
    url: null,
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="12" fill="#1DBF73" />
        <text x="12" y="16.4" textAnchor="middle" fontFamily="Arial, Helvetica, sans-serif" fontSize="12.5" fontWeight="700" fill="#fff">fi</text>
      </svg>
    ),
  },
  OTHER: {
    label: 'Other',
    longLabel: 'Other',
    url: null,
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" />
        <path d="M12 8v5M12 16h.01" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
    ),
  },
}

export function sourceKey(source) {
  return source && SOURCE_META[source] ? source : 'OTHER'
}
